import { useStaticQuery, graphql } from 'gatsby'

export const useContactQuery = () => {
  const { wpPage } = useStaticQuery(graphql`
    query ContactQuery {
      wpPage(title: { eq: "Home" }) {
        contact {
          contact {
            mobileBackgroundImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                }
              }
            }
            desktopBackgroundImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                }
              }
            }
            mobileCutout {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP, sizes: "91vw")
                }
              }
            }
            desktopCutout {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP, sizes: "40vw")
                }
              }
            }
            mobileVan {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP, sizes: "83vw")
                }
              }
            }
            desktopVan {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP, sizes: "42vw")
                }
              }
            }
            title
            text
            submitButtonText
            formOptions {
              value
              label
            }
          }
        }
      }
    }
  `)
  return wpPage.contact.contact
}
